<gb-start-page
    [logoClaim]="''"
    [appNamePrefix]="appNamePrefix"
    [appNameSuffix]="appNameSuffix"
    [titleStateReference]="''"
    [showLoginBtn]="false"
>

    <ui-view />
</gb-start-page>
